import { Badge } from "@/components/ui/badge";
import { ArrowDown, ArrowUp, Minus } from "lucide-react";

export const isDecimal = (p) => /gram|\bg\b|ml|kg|litre|liter/i.test(`${p.unit || ""} ${p.selling_mode || ""}`);
export const fmt = (n) => Number(n || 0).toLocaleString("en-ZA", { maximumFractionDigits: 2 });
export const round = (n) => Math.round(Number(n) * 10000) / 10000;

export function Variance({ value, testid }) {
  if (value === null || value === undefined) return <span className="text-muted-foreground" data-testid={testid}>Not counted</span>;
  const v = round(value);
  if (v === 0) return (
    <span className="inline-flex items-center gap-1 text-muted-foreground font-mono" data-testid={testid}>
      <Minus className="w-3 h-3" /> 0
    </span>
  );
  const up = v > 0;
  return (
    <span className={`inline-flex items-center gap-1 font-mono font-semibold ${up ? "text-emerald-700" : "text-[#C05746]"}`} data-testid={testid}>
      {up ? <ArrowUp className="w-3 h-3" /> : <ArrowDown className="w-3 h-3" />}
      {up ? "+" : "−"}{fmt(Math.abs(v))}
    </span>
  );
}

const STATUS = {
  draft: "bg-slate-100 text-slate-700",
  pending: "bg-amber-100 text-amber-800",
  approving: "bg-amber-100 text-amber-800",
  approved: "bg-emerald-100 text-emerald-800",
  rejected: "bg-red-100 text-red-800",
};

export function StatusBadge({ status, testid }) {
  const s = status || "approved";
  return <Badge className={`${STATUS[s] || ""} hover:${STATUS[s] || ""} capitalize`} data-testid={testid}>{s === "pending" ? "Pending approval" : s}</Badge>;
}

export function Summary({ lines }) {
  const up = lines.filter((l) => round(l.variance) > 0).length;
  const down = lines.filter((l) => round(l.variance) < 0).length;
  const same = lines.length - up - down;
  return (
    <div className="flex flex-wrap gap-2 text-xs" data-testid="recon-summary">
      <Badge variant="outline">{lines.length} counted</Badge>
      <Badge variant="outline" className="border-emerald-300 text-emerald-800">{up} increase{up === 1 ? "" : "s"}</Badge>
      <Badge variant="outline" className="border-red-300 text-[#C05746]">{down} reduction{down === 1 ? "" : "s"}</Badge>
      <Badge variant="outline">{same} unchanged</Badge>
    </div>
  );
}
